var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertObservaciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.5,
    viewBox: "0 0 22 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12330",
    "data-name": "Group 12330",
    transform: "translate(-1818 -566.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_391",
    "data-name": "Ellipse 391",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(1818 567)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(1829 583.5)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.617,
    y: 0
  }, "!")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertObservaciones);
export default __webpack_public_path__ + "static/media/alert-observaciones.b5e489fcf3ba7fa4cefd5bde0db8d9c8.svg";
export { ForwardRef as ReactComponent };